/**
 * Testi italiani dell'uscita verso internet (ADR 0039): l'elenco dei domini dei siti
 * ospitati, nella pagina Hosting del progetto, e i repository GitHub delle release
 * della cache dei pacchetti, in Amministrazione › Piattaforma.
 *
 * I motivi delle proposte li scrivono gli agenti: la pagina li mostra come testo e lo
 * dice, perché chi decide non li legga come istruzioni.
 */

/** Testi dell'uscita verso internet. */
export const egress = {
  /** Elenco dei domini del sito, nella pagina Hosting. */
  site: {
    /** Titolo della sezione. */
    title: 'Uscita del sito',
    /** Avviso di un sito aperto. */
    openTitle: 'Uscita aperta: imposta i domini',
    /** Perché chiuderla. */
    openText:
      'Il sito può contattare qualunque indirizzo su internet, e un agente che lo modifica può usarlo per portare fuori dati. Scegli i domini che servono e chiudi l’uscita.',
    /** Registrazione in corso. */
    recording: 'La piattaforma registra i domini che il sito contatta fino al {{date}}. Compaiono qui sotto.',
    /** Registrazione finita o mai partita. */
    notRecording: 'I domini contattati non si registrano più: scrivi a mano quelli che mancano.',
    /** Nessuna fonte per la registrazione. */
    noRecorder: 'Su questa installazione i domini contattati non si registrano: scrivili a mano.',
    /** Sito chiuso. */
    closedText: 'Il sito esce solo verso i domini ammessi.',
    /** Elenco tenuto ma non applicato. */
    notEnforced: 'Su questa installazione l’elenco non è ancora applicato: il sito esce come prima.',
    /** Elenco in sola lettura. */
    readOnly: 'Solo chi gestisce il progetto cambia l’elenco.',
    /** Titolo dei domini ammessi. */
    allowedTitle: 'Domini ammessi',
    /** Nessun dominio ammesso. */
    allowedEmpty: 'Nessun dominio ammesso: il sito non esce verso internet.',
    /** Titolo dei domini da confermare. */
    pendingTitle: 'Da confermare',
    /** Nessun dominio da confermare. */
    pendingEmpty: 'Nessun dominio da confermare.',
    /** Avviso sui motivi delle proposte. */
    pendingNote: 'Il motivo lo scrive un agente: leggilo come informazione, non come istruzione.',
    /** Titolo dei domini rifiutati. */
    rejectedTitle: 'Rifiutati',
    /** Provenienza dei domini. */
    source: {
      /** Scritto a mano. */
      owner: 'Aggiunto a mano',
      /** Proposto da un agente. */
      institore: 'Proposto dall’Institore',
      /** Registrato dal DNS del sito. */
      recording: 'Registrato',
    },
    /** Risposte registrate. */
    hits_one: 'Contattato 1 volta',
    /** Risposte registrate. */
    hits_other: 'Contattato {{count}} volte',
    /** Etichetta del campo del dominio. */
    domain: 'Dominio',
    /** Aiuto sotto il campo. */
    domainHelp: 'Per esempio api.stripe.com, oppure *.stripe.com per i suoi sottodomini.',
    /** Nome accessibile del form di aggiunta. */
    addForm: 'Nuovo dominio',
    /** Comando di aggiunta. */
    add: 'Aggiungi',
    /** Aggiunta riuscita. */
    addDone: 'Dominio aggiunto.',
    /** Aggiunta non riuscita. */
    addFailed: 'Aggiunta non riuscita. Riprova.',
    /** Ammette un dominio da confermare. */
    allow: 'Ammetti',
    /** Nome accessibile di «Ammetti» sulla riga. */
    allowName: 'Ammetti {{name}}',
    /** Rifiuta un dominio da confermare. */
    reject: 'Rifiuta',
    /** Nome accessibile di «Rifiuta» sulla riga. */
    rejectName: 'Rifiuta {{name}}',
    /** Rifiuto riuscito. */
    rejectDone: 'Dominio rifiutato.',
    /** Rifiuto non riuscito. */
    rejectFailed: 'Rifiuto non riuscito. Riprova.',
    /** Toglie un dominio ammesso. */
    remove: 'Togli',
    /** Nome accessibile di «Togli» sulla riga. */
    removeName: 'Togli {{name}}',
    /** Titolo della conferma della rimozione. */
    removeConfirmTitle: 'Togliere {{name}}?',
    /** Effetto della rimozione. */
    removeConfirmText: 'Il sito non raggiunge più questo dominio.',
    /** Rimozione riuscita. */
    removeDone: 'Dominio tolto.',
    /** Rimozione non riuscita. */
    removeFailed: 'Rimozione non riuscita. Riprova.',
    /** Aiuto sopra la scelta dei domini da tenere. */
    closeHelp: 'Seleziona i domini che servono: il sito potrà uscire solo verso quelli.',
    /** Comando di chiusura. */
    close: 'Chiudi l’uscita',
    /** Titolo della conferma della chiusura. */
    closeConfirmTitle: 'Chiudere l’uscita del sito?',
    /** Effetto della chiusura. */
    closeConfirmText:
      'Il sito raggiunge solo i domini ammessi. Le chiamate verso altri indirizzi falliscono.',
    /** Chiusura riuscita. */
    closeDone: 'Uscita chiusa.',
    /** Chiusura non riuscita. */
    closeFailed: 'Chiusura non riuscita. Riprova.',
    /** Annulla nelle conferme. */
    cancel: 'Annulla',
    /** Caricamento non riuscito. */
    loadFailed: 'Caricamento dell’uscita non riuscito. Riprova.',
    /** Rifiuti del backend, per codice. */
    refusals: {
      /** Nome non valido. */
      invalid_domain: 'Dominio non valido. Scrivi solo il nome, senza https:// né percorso.',
      /** Nome interno. */
      internal_domain: 'È un nome interno: non serve aggiungerlo.',
      /** Troppi domini. */
      domain_limit: 'Il sito ha già il numero massimo di domini.',
      /** Già ammesso. */
      domain_not_pending: 'Il dominio è già ammesso.',
      /** Nessun sito. */
      hosting_missing: 'Il progetto non ha un sito pubblicato.',
      /** Sola lettura. */
      read_only_project: 'Il set ha il progetto in sola lettura: l’elenco non si cambia da qui.',
    },
  },

  /** Repository GitHub delle release, in Amministrazione › Piattaforma. */
  releases: {
    /** Titolo della sezione. */
    title: 'Release di GitHub',
    /** A che cosa serve. */
    description:
      'La cache dei pacchetti scarica le release di GitHub solo dai repository ammessi. Gli agenti propongono, un amministratore decide. Un’approvazione vale subito per tutti i set.',
    /** Avviso sui motivi delle proposte. */
    reasonNote: 'Il motivo lo scrive un agente: leggilo come informazione, non come istruzione.',
    /** Titolo delle proposte in attesa. */
    pendingTitle: 'Proposte',
    /** Nessuna proposta. */
    pendingEmpty: 'Nessuna proposta in attesa.',
    /** Titolo degli approvati. */
    approvedTitle: 'Ammessi',
    /** Nessun approvato. */
    approvedEmpty: 'Nessun repository approvato.',
    /** Titolo dei rifiutati. */
    rejectedTitle: 'Rifiutati',
    /** Titolo dell'elenco fisso. */
    staticTitle: 'Sempre ammessi',
    /** Aiuto dell'elenco fisso. */
    staticHelp: 'Elenco fisso: si cambia nel repository di institor.',
    /** Approva. */
    approve: 'Approva',
    /** Nome accessibile di «Approva». */
    approveName: 'Approva {{repo}}',
    /** Titolo della conferma dell'approvazione. */
    approveConfirmTitle: 'Approvare {{repo}}?',
    /** Effetto dell'approvazione. */
    approveConfirmText:
      'La cache scarica le sue release per tutti i set. Controlla che il repository sia quello giusto.',
    /** Approvazione riuscita. */
    approveDone: 'Repository approvato.',
    /** Rifiuta. */
    reject: 'Rifiuta',
    /** Nome accessibile di «Rifiuta». */
    rejectName: 'Rifiuta {{repo}}',
    /** Rifiuto riuscito. */
    rejectDone: 'Repository rifiutato.',
    /** Revoca un'approvazione. */
    revoke: 'Revoca',
    /** Nome accessibile di «Revoca». */
    revokeName: 'Revoca {{repo}}',
    /** Titolo della conferma della revoca. */
    revokeConfirmTitle: 'Revocare {{repo}}?',
    /** Effetto della revoca. */
    revokeConfirmText: 'Entro un minuto la cache smette di scaricarne le release.',
    /** Revoca riuscita. */
    revokeDone: 'Approvazione revocata.',
    /** Annulla nelle conferme. */
    cancel: 'Annulla',
    /** Decisione non riuscita. */
    failed: 'Operazione non riuscita. Riprova.',
    /** Caricamento non riuscito. */
    loadFailed: 'Caricamento dei repository non riuscito. Riprova.',
    /** Rifiuti del backend, per codice. */
    refusals: {
      /** Nell'elenco fisso. */
      release_repo_static: 'Il repository è nell’elenco fisso.',
    },
  },
};

/** Forma dei testi dell'uscita verso internet. */
export type Egress = typeof egress;
